import React from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import { Grid, Layout } from "antd";

import navigationConfig from "configs/NavigationConfig";
import {
  DIR_LTR,
  DIR_RTL,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { useFirestoreConnect } from "react-redux-firebase";
import {
  FIRESTORE_BUSINESS_QUOTE_REQUESTS_TABLE,
  FIRESTORE_CONFIGURATOR_ENTRIES_TABLE,
  FIRESTORE_CONTACT_REQUESTS_TABLE,
  FIRESTORE_LEAD_CATEGORIES_DOC,
  FIRESTORE_LEAD_CATEGORIES_TABLE,
  FIRESTORE_PRODUCT_FOLDER_REQUESTS_TABLE,
  FIRESTORE_PROJECTS_TABLE,
  FIRESTORE_QUOTE_REQUESTS_TABLE,
  FIRESTORE_VACANCY_APPLICATIONS_TABLE,
  FIRESTORE_VOICE_MEETING_REQUESTS_TABLE,
} from "../../constants/FirestoreConstant";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction }) => {
  // Fetch all collections from Firestore and put in redux store
  useFirestoreConnect([
    { collection: FIRESTORE_PROJECTS_TABLE },
    { collection: FIRESTORE_LEAD_CATEGORIES_TABLE, doc: FIRESTORE_LEAD_CATEGORIES_DOC },
    { collection: FIRESTORE_QUOTE_REQUESTS_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_BUSINESS_QUOTE_REQUESTS_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_CONFIGURATOR_ENTRIES_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_CONTACT_REQUESTS_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_VOICE_MEETING_REQUESTS_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_VACANCY_APPLICATIONS_TABLE, orderBy: ["createdAt", "desc"] },
    { collection: FIRESTORE_PRODUCT_FOLDER_REQUESTS_TABLE, orderBy: ["createdAt", "desc"] },
  ]);
  const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname);
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes("lg");
  const isNavSide = navType === NAV_TYPE_SIDE;
  const isNavTop = navType === NAV_TYPE_TOP;
  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <Layout>
      <HeaderNav isMobile={isMobile} />
      {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout className="app-container">
        {isNavSide && !isMobile ? <SideNav routeInfo={currentRouteInfo} /> : null}
        <Layout className="app-layout" style={{ ...getLayoutDirectionGutter(), paddingLeft: 0, minHeight: "100vh" }}>
          <div className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}>
            <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
            <Content>
              <AppViews />
            </Content>
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && <MobileNav />}
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
